import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy, inject } from '@angular/core';
import { GapCheckSection } from '../../../../shared/models/gap-check-section';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Rating, RatingService } from '../../../../services/rating-service/rating-service';

@Component({
  selector: 'app-summary-report',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './summary-report.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./summary-report.css'],
})
export class SummaryReport implements OnInit, OnChanges {
  private ratingService = inject(RatingService);

  @Input() title = '';
  @Input() standard = '27001';
  @Input() companyName = '';
  @Input() contactName = '';
  @Input() email = '';
  @Input() assessmentDate = '';
  @Input() reportVersion = 'v1.0.0';
  @Input() sections: GapCheckSection[] = [];
  @Input() totalGraphicScore = 0;

  rating: Rating | null = null;
  ratings: Rating[] = [];

  // ✅ Pages object
  pagedSections: Record<string, GapCheckSection[]> = { page1: [], page2: [] };


  ngOnInit(): void {
    this.updateReport();
  }

  ngOnChanges(): void {
    this.updateReport();
  }

  updateReport(): void {
    this.ratings = this.ratingService.getRatings();
    this.rating = this.ratingService.getRating(this.totalGraphicScore);

    const pageLimits = [12, 31]; // Define cutoffs: page1=1-12, page2=13-31, page3=rest
    let currentPage = 1;
    let count = 0;
    let currentPageSections: GapCheckSection[] = [];
    this.pagedSections = { page1: [], page2: [] }; // Reset pages

    for (const section of this.sections) {
      let sectionQuestions = [...section.questions];

      while (sectionQuestions.length > 0) {
        // Determine how many questions to take for this page
        const pageLimit = pageLimits[currentPage - 1] || Infinity;
        const remainingForPage = pageLimit - count;
        const questionsToTake = sectionQuestions.slice(0, remainingForPage);

        if (questionsToTake.length > 0) {
          currentPageSections.push({
            ...section,
            questions: questionsToTake,
          });
          count += questionsToTake.length;
          sectionQuestions = sectionQuestions.slice(questionsToTake.length);
        }

        // If page is full, store it and start next page
        if (count >= pageLimit) {
          this.pagedSections[`page${currentPage}`] = currentPageSections;
          currentPage++;
          count = 0;
          currentPageSections = [];
        }
      }
    }

    // Store last page if any remaining questions
    if (currentPageSections.length > 0) {
      this.pagedSections[`page${currentPage}`] = currentPageSections;
    }
  }

  getClauseNumber(clauseRef: string | undefined): string {
    if (!clauseRef) return 'N/A';
    return clauseRef.split('.')[0];
  }
}